import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const SnackbarRoot = styled(Paper)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  padding: '6px 16px',
  backgroundColor: '#d32f2f',
  color: '#fff',
  borderRadius: 4,
  minWidth: 288,
  maxWidth: 568,
});

export const SnackbarMessage = styled(Typography)({
  padding: '8px 0',
});

export const SnackbarCloseButton = styled(IconButton)({
  color: 'inherit',
  flexShrink: 0,
  marginLeft: 4,
});
